import { render } from "./Animation.vue?vue&type=template&id=43feeec6&ts=true"
import script from "./Animation.vue?vue&type=script&lang=ts"
export * from "./Animation.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/nouns/nounslove-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__